<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

interface Testimonial {
	id: number
	message: string
	author: string
	avatar: string
	platform: 'discord' | 'reddit'
	url: string
}

const { t } = useI18n()

const testimonials = ref<Testimonial[]>([
	{
		id: 1,
		message: 'Absolutely a solid service, generous with the perks of subscription, handles native prompt writing as well as being greatly geared towards Tag-prompt generation. the ease of prompt generation as well as the speed of result production truly make this a solid service for experience users as well as a great introductory service for those new to AI generation tools. a plethora of art styles are readily available and presented in a way that ensures clear communication of the art style to the user. <br>-AIBob',
		author: 'ChemLaird',
		avatar: 'https://cdn.discordapp.com/avatars/95620676211191808/633d04a5d7ae498536d69853b780d78a.webp?size=80',
		platform: 'discord',
		url: 'https://discord.com/channels/1151495554799509514/1380584622714519562/1380586997000966265',
	},
	{
		id: 2,
		message: 'I\'m genuinely impressed with how coherent almost every image is. The output quality and consistency is super impressive overall.',
		author: 'Grey',
		avatar: 'https://cdn.discordapp.com/guilds/1151495554799509514/users/357361608705703937/avatars/c8e70b4fdf2cd2cceba5672795ea9fc2.webp?size=128',
		platform: 'discord',
		url: 'https://discord.com/channels/1151495554799509514/1348957954220490815/1349717376106496041',
	},
	{
		id: 3,
		message: 'My account\'s collection is slowly becoming my taste heaven. I suppose that was one of the goal of the website hehe',
		author: 'Rahl',
		avatar: '/image/pp31.webp',
		platform: 'discord',
		url: 'https://discord.com/channels/1151495554799509514/1153605294023266447/1368179498352246855',
	},
])

function getAvatarFallback(name: string) {
	return name.charAt(0).toUpperCase()
}

function openTestimonial(url: string) {
	window.open(url, '_blank', 'noopener,noreferrer')
}
</script>

<template>
	<div class="">
		<div class="max-w-7xl mx-auto">
			<div class="text-center mb-8">
				<h2 class="text-4xl md:text-5xl font-bold text-white mb-4">
					{{ t('testimonial.title') }}
				</h2>
				<div class="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full" />
			</div>

			<!-- Testimonials Grid -->
			<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
				<div
					v-for="testimonial in testimonials"
					:key="testimonial.id"
					class="group cursor-pointer border-2 border-solid border-transparent rounded-xl px-6 py-4 bg-gradient-to-b from-slate-900 to-slate-800 shadow-lg hover:shadow-xl transition-all duration-500 hover:border-blue-400/50 relative overflow-hidden"
					@click="openTestimonial(testimonial.url)"
				>
					<!-- Background accents -->
					<div class="absolute -top-10 -right-10 w-40 h-40 bg-blue-500/10 rounded-full blur-xl" />
					<div class="absolute -bottom-10 -left-10 w-40 h-40 bg-purple-500/10 rounded-full blur-xl" />

					<!-- Header with platform icon and username -->
					<div class="flex items-center gap-3 mb-4 relative">
						<!-- Profile Picture -->
						<div class="relative flex-shrink-0">
							<img
								v-if="testimonial.avatar"
								:src="testimonial.avatar"
								:alt="testimonial.author"
								class="w-10 h-10 rounded-full object-cover"
							>
							<div
								v-else
								class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-semibold text-sm"
							>
								{{ getAvatarFallback(testimonial.author) }}
							</div>
						</div>

						<!-- Username -->
						<span class="text-slate-200 font-semibold text-sm flex-1">
							{{ testimonial.author }}
						</span>
						<!-- Platform Icon -->
						<div
							:class="{
								'bg-gradient-to-br from-indigo-400 via-indigo-500 to-blue-600': testimonial.platform === 'discord',
								'bg-gradient-to-br from-orange-400 via-orange-500 to-red-600': testimonial.platform === 'reddit',
							}"
							class="flex items-center justify-center w-8 h-8 rounded-xl shadow-md flex-shrink-0"
						>
							<i
								v-if="testimonial.platform === 'discord'"
								class="pi pi-discord text-xl"
							/>
							<i
								v-else
								class="pi pi-reddit text-xl"
							/>
						</div>
					</div>

					<!-- Message content -->
					<div class="relative">
						<p
							class="text-slate-200 leading-relaxed text-sm"
							v-html="testimonial.message "
						/>
					</div>
				</div>
			</div>

			<!-- Stats section -->
			<!-- 		<div class="mt-12 text-center">
				<div class="inline-flex items-center gap-8 bg-slate-800/50 rounded-xl px-8 py-4">
					<div class="text-center">
						<div class="text-2xl font-bold text-slate-200">
							{{ testimonials.length }}+
						</div>
						<div class="text-slate-400 text-sm">
							Happy Users
						</div>
					</div>
					<div class="w-px h-8 bg-slate-600" />
					<div class="text-center">
						<div class="text-2xl font-bold text-slate-200">
							{{ testimonials.filter(t => t.platform === 'discord').length }}
						</div>
						<div class="text-slate-400 text-sm">
							Discord Reviews
						</div>
					</div>
					<div class="w-px h-8 bg-slate-600" />
					<div class="text-center">
						<div class="text-2xl font-bold text-slate-200">
							{{ testimonials.filter(t => t.platform === 'reddit').length }}
						</div>
						<div class="text-slate-400 text-sm">
							Reddit Posts
						</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<style scoped>
.lucide-button-icon {
	@apply w-4 h-4;
}
</style>
